﻿require('../css/index.css');
var explorer = navigator.userAgent ;
if (explorer.indexOf("MSIE") >= 0) {
    if(navigator.userAgent.indexOf("MSIE 6.0")>0){
        alert("您使用的浏览器内核版本为IE6，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
    if(navigator.userAgent.indexOf("MSIE 7.0")>0){
        alert("您使用的浏览器内核版本为IE7，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
    if(navigator.userAgent.indexOf("MSIE 9.0")>0 && !window.innerWidth){
        alert("您使用的浏览器内核版本为IE8，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
    if(navigator.userAgent.indexOf("MSIE 9.0")>0){
        alert("您使用的浏览器内核版本为IE9，本页面最低支持IE10以上，请升级浏览器或更换其他浏览器,以免影响体验！");
    }
}

function navClick(e,n){
    $(e).siblings('li').removeClass('actv');
    $(e).addClass('actv');
    $('#fp-nav ul li:nth-child('+n+') a').click();
}

    
/* 替换图片地址即可，一般从服务器动态获取 */
/*图片数组，用来动态计算有几个bn图(目前写死)*/
var images = ['./imgs/1.jpg','./imgs/2.jpg','./imgs/3.jpg'];
var n = 0,inte='';

$('div.bottom i').click(function(){carouselN(parseInt($(this).attr('name')))})
$('div.rmleft').click(function(){carouselN(n-1)})
$('div.rmright').click(function(){carouselN(n+1)})

function carouselN(x){
    clearInterval(inte);
    var w = $(window).width();
    n=x;
    if(x>images.length-1){n=0}
    if(x<0){n=images.length-1}
    $('div.bottom i').css('background', '#fff');
    $('div.bottom i').eq(n).css({'background':'#000','border':'1px solid #fff'});
    console.log(n)
    if(n==0){
        $('#Carousel div img').css('left', '0')
    }else{
        $('#Carousel div img').css('left', -n * w-5);
    }
    carousel();
}

function carousel() {
    inte = setInterval(function () {
        n > images.length ? n = 0 : n;
        carouselN(n);
        n++;
    }, 5000);
}

$(window).resize(function(){
    carouselN(n)
})

// $(function(){
//     carousel()
// })


//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 1
// module chunks = 2